import { TrustpilotExcellent } from "./Trustpilot";
import { TrustpilotExtended } from "./TrustpilotExtended";
import type { TrustpilotExtendedProps } from "./TrustpilotExtended";

export { TrustpilotExcellent, TrustpilotExtended, TrustpilotExtendedProps };
